export class ConfigError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ConfigError";
  }
}

export interface RuntimeConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  appStoreUrl: string;
  playStoreUrl: string;
  appLinkBase: string;
}

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new ConfigError(`${name} is not configured`);
  }
  return value;
}

// Only SUPABASE_URL / SUPABASE_ANON_KEY are required for the page to do
// anything at all (they're needed just to call preview_invitation_public).
// The other three are optional and degrade individually — a missing
// APP_STORE_URL just hides that one button (see deepLinks.ts) rather than
// failing the whole page.
export function loadConfig(env: ImportMetaEnv = import.meta.env): RuntimeConfig {
  return {
    supabaseUrl: required("SUPABASE_URL", env.SUPABASE_URL),
    supabaseAnonKey: required("SUPABASE_ANON_KEY", env.SUPABASE_ANON_KEY),
    appStoreUrl: env.APP_STORE_URL ?? "",
    playStoreUrl: env.PLAY_STORE_URL ?? "",
    appLinkBase: env.DARUVIX_APP_LINK_BASE ?? "",
  };
}
